export class HttpConstants {
  static readonly SKIP_INTERCEPTOR_HEADER = 'X-Skip-Interceptor';
}
